import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import {
    AlertsFilter,
    Alerts,
} from '../../../../../shared/types/legalProceedings/alerts';
import { asyncGetAlerts } from '../../../../../services/alerts.service';
import { ISelect } from '../../../../../shared/types/shared';
import DateTimeFormat from '../../../../components/dateTimeFormat';
import { AlertsListActions } from './actions';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import {
    isOnlyViewProfile,
    isOperativeProfile,
} from '../../../../../shared/types/profiles';

export const useAlertList = (filters?: AlertsFilter) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Alerts[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<AlertsFilter>({});

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<Alerts>[] = [];

    if (!isOnlyViewProfile(type) && !isOperativeProfile(type)) {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <AlertsListActions id={row.id} />,
        });
    }

    columns.push(
        {
            field: 'ruleNumber',
            headerName: 'N regla',
            minWidth: 120,
            flex: 0.2,
            valueGetter: (params) => params.row.ruleNumber || 'N/A',
        },
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 150,
            flex: 0.9,
            valueGetter: (params) => params.row.name || 'N/A',
        },
        {
            field: 'alertStatus',
            headerName: 'Estado alerta',
            minWidth: 120,
            flex: 0.6,
            valueGetter: (params) => (params.row?.status as ISelect)?.name,
        },
        {
            field: 'newStatus',
            headerName: 'Nuevo estado alerta',
            minWidth: 120,
            flex: 0.6,
            valueGetter: (params) => (params.row?.newStatus as ISelect)?.name,
        },
        {
            field: 'active',
            headerName: 'Activo',
            minWidth: 120,
            flex: 0.2,
            valueGetter: (params) => (params.row?.active ? 'Sí' : 'No'),
        },
        {
            field: 'created_at',
            headerName: 'Fecha creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.created_at} />,
        }
    );

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        asyncGetAlerts(finalFilters, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
